export default __webpack_public_path__ + "36a5d2e53230cdabe6cb6688f50a2056.png";